import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import InstagramPreviewCarousel from './InstagramPreviewCarousel'

import { FILE_TYPE, FILE_URL, MEDIA_ITEMS } from '../fields'

import useStyles from '../styles'

const InstagramPreviewMediaItems = ({ post }) => {
  const classes = useStyles()

  const { [MEDIA_ITEMS]: mediaItems } = post

  const isCarouselPreview = mediaItems?.length > 1

  const renderMediaItem = useCallback(
    mediaItem => {
      return mediaItem[FILE_TYPE] === 'video' ? (
        <video className={classes.postMediaItem} src={mediaItem[FILE_URL]} autoPlay loop muted>
          <source src={mediaItem[FILE_URL]} />
        </video>
      ) : (
        <img className={classes.postMediaItem} src={mediaItem[FILE_URL]} alt="post_image" />
      )
    },
    [classes.postMediaItem]
  )

  if (!mediaItems?.length) {
    return null
  }

  if (isCarouselPreview) {
    return <InstagramPreviewCarousel mediaItems={mediaItems} renderMediaItem={renderMediaItem} />
  }

  return <div className={classes.postMediaItemsContainer}>{renderMediaItem(mediaItems[0])}</div>
}

InstagramPreviewMediaItems.propTypes = {
  post: PropTypes.object.isRequired
}

export default InstagramPreviewMediaItems
